"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputValidation = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var commonRegex = _interopRequireWildcard(require("./../commonRegex"));
var _InputType = require("./InputType");
var errorCode = {
  FormatError: 0,
  LengthError: 1,
  RequiredError: 2,
  NumericalError: 3
};
var phoneNumberValidation = function phoneNumberValidation(text, isRequired) {
  var numbers = text.replace(/-|_/gi, '');
  if (isNaN(Number(numbers))) {
    return errorCode.NumericalError;
  }
  if (numbers.length === 0 && isRequired) {
    return errorCode.RequiredError;
  }
  if (numbers.length !== 10) {
    return errorCode.LengthError;
  }
  if (!commonRegex.PhoneNumber.test(text)) {
    return errorCode.FormatError;
  }
  return null;
};
var mileageValidation = function mileageValidation(text, isRequired) {
  var numbers = text.replace(/,/gi, '');
  if (isNaN(Number(numbers))) {
    return errorCode.NumericalError;
  }
  if (numbers.length === 0 && isRequired) {
    return errorCode.RequiredError;
  }
  if (numbers.length > 6) {
    return errorCode.LengthError;
  }
  if (!commonRegex.Mileage.test(text)) {
    return errorCode.FormatError;
  }
  return null;
};
var passwordValidation = function passwordValidation(text, isRequired) {
  if (!text && isRequired) {
    return errorCode.RequiredError;
  }
  return null;
};
var vinNumberValidation = function vinNumberValidation(text, isRequired) {
  if (!text && isRequired) {
    return errorCode.RequiredError;
  }
  if (text.length > 17) {
    return errorCode.LengthError;
  }
  return null;
};
var currencyValidation = function currencyValidation(text, isRequired) {
  var numbers = text.replace(/,|\$/gi, '');
  if (isNaN(Number(numbers))) {
    return errorCode.NumericalError;
  }
  if (numbers.length === 0 && isRequired) {
    return errorCode.RequiredError;
  }
  if (!commonRegex.Currency.test(text)) {
    return errorCode.FormatError;
  }
  return null;
};
var emailValidation = function emailValidation(text, isRequired) {
  if (!isRequired && !text) {
    return null;
  }
  if (!text && isRequired) {
    return errorCode.RequiredError;
  }
  if (text && text.length < 6) {
    return errorCode.LengthError;
  }
  if (!commonRegex.Email.test(text)) {
    return errorCode.FormatError;
  }
  return null;
};
var zipCodeValidation = function zipCodeValidation(text, isRequired) {
  if (isNaN(Number(text))) {
    return errorCode.NumericalError;
  }
  if (!text && isRequired) {
    return errorCode.RequiredError;
  }
  if (text.length !== 5) {
    return errorCode.LengthError;
  }
  return null;
};
var inputValidation = function inputValidation(inputType, text, isRequired) {
  var _validator;
  var validator = (_validator = {}, (0, _defineProperty2["default"])(_validator, _InputType.InputType.PhoneNumber, phoneNumberValidation(text, isRequired)), (0, _defineProperty2["default"])(_validator, _InputType.InputType.Mileage, mileageValidation(text, isRequired)), (0, _defineProperty2["default"])(_validator, _InputType.InputType.Password, passwordValidation(text, isRequired)), (0, _defineProperty2["default"])(_validator, _InputType.InputType.VinNumber, vinNumberValidation(text, isRequired)), (0, _defineProperty2["default"])(_validator, _InputType.InputType.Currency, currencyValidation(text, isRequired)), (0, _defineProperty2["default"])(_validator, _InputType.InputType.Email, emailValidation(text, isRequired)), (0, _defineProperty2["default"])(_validator, _InputType.InputType.ZipCode, zipCodeValidation(text, isRequired)), _validator);
  return validator[inputType];
};
exports.inputValidation = inputValidation;